<template>
    <LoginModal v-model:open="isOpen" show-continue @login-success="emits('login-success')" @continue="emits('continue')" />
</template>

<script setup lang="ts">
import LoginModal from '@/components/modals/LoginModal.vue';

const isOpen = defineModel<boolean>();

const emits = defineEmits<{
    'login-success': [];
    continue: [];
}>();
</script>
